/**
 * This function returns a shuffled version of the array passed in. This is called the Fisher-Yates shuffle
 * and the reference used is https://javascript.info/task/shuffle.
 *
 * @params array
 * @returns {string[]}
 */
export function shuffle(array: string[]): string[] {
  const result = [...array];
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
